import { STORAGE_KEYS } from './constants';
export function getStoredTokens() {
    try {
        const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
        const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
        const expiresAt = localStorage.getItem(STORAGE_KEYS.TOKEN_EXPIRES_AT);
        if (!accessToken || !refreshToken || !expiresAt)
            return null;
        return { accessToken, refreshToken, expiresAt: Number(expiresAt) };
    }
    catch {
        return null;
    }
}
export function getStoredUser() {
    try {
        const raw = localStorage.getItem(STORAGE_KEYS.USER);
        if (!raw)
            return null;
        return JSON.parse(raw);
    }
    catch {
        return null;
    }
}
export function storeAuth(tokens, user) {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, tokens.accessToken);
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, tokens.refreshToken);
    localStorage.setItem(STORAGE_KEYS.TOKEN_EXPIRES_AT, String(tokens.expiresAt));
    // On token refresh the backend returns no user, so keep the stored one.
    if (user)
        localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
}
export function clearAuth() {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.TOKEN_EXPIRES_AT);
    localStorage.removeItem(STORAGE_KEYS.USER);
}
/**
 * "Logged in" = we hold a token pair. The ACCESS token expiring (1 h) does NOT
 * end the session: apiClient renews it silently with the refresh token on the
 * next request. Treating an expired access token as "logged out" sent users to
 * /login after any reload or navigation >1 h idle (bookmark in the morning,
 * Safari restoring a tab…) — the main cause of the "me cierra la sesión al
 * rato" reports (2026-09-17). A dead refresh token still logs out: the
 * refresh fails and apiClient's onUnauthenticated() redirects to /login.
 */
export function isAuthenticated() {
    return getStoredTokens() !== null;
}
export function isTokenExpiringSoon(thresholdMs = 60_000) {
    const tokens = getStoredTokens();
    if (!tokens)
        return false;
    return Date.now() > tokens.expiresAt - thresholdMs;
}
//# sourceMappingURL=auth.js.map